import { DIAGONAL_CORNER_OPTIONS, QTECode } from '@common/constants';
import { DiagonalCornerModel } from '@common/models';

export const getCornerType = (corner?: DiagonalCornerModel): string => {
    if (corner?.name === DIAGONAL_CORNER_OPTIONS.REMOVE_DIAGONAL_CORNER) {
        return DIAGONAL_CORNER_OPTIONS.REMOVE_DIAGONAL_CORNER;
    }
    if (corner?.qteCodeId === QTECode.InsideCorner) {
        return DIAGONAL_CORNER_OPTIONS.INSIDE_CORNER;
    }
    return DIAGONAL_CORNER_OPTIONS.OUTSIDE_CORNER;
};
